import ComponentBase from "../../../../public/component/component_base";
import TablePokerBase from "../../../../table/module/table_base/table_poker_base";



const { ccclass, property } = cc._decorator;


@ccclass
export default class BullPokerCom extends TablePokerBase{

    @property(Number)
    seatIndex : number = 0;


}